
import './App.css';
import Header from './Components/Header/header';
import Projects from './Components/Projects/projects';
import About from './Components/about/about';
import Resume from './Components/resume/resume';
import { BrowserRouter, Route, Routes, Navigate, NavLink } from "react-router-dom";
import Home from './Components/Home/home';
import Footer from './Components/Footer/footer'
import 'animate.css';
import Loading from "./Components/loading/loading";
import { useState, useEffect } from 'react';
function App() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500); // Adjust time as needed
  }, []);
  return (
    <div>
         {isLoading ? (
      <Loading />
    ) : (
          <BrowserRouter>

      <Header/>
      <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="about" element={<About/>}/>
                    <Route path='resume' element={<Resume/>}/>
                    <Route path='projects' element={<Projects/>}/>
                    </Routes>
                    <Footer/>
      </BrowserRouter>
    )}
    </div>
  );
}

export default App;
